<template>
  <b-form-group
    :label="label"
    :label-class="{ required }"
    :invalid-feedback="error"
    :state="error ? false : null">
    <component
      :is="component"
      v-bind="$props"
      @input="$emit('input', $event)">
      <template v-slot:tag="{ option }"><slot name="tag" :option="option"></slot></template>
    </component>
  </b-form-group>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import EntityFieldMixin from 'vue-forms/mixins/EntityFieldMixin';

export default {
  mixins: [ FormFieldMixin, EntityFieldMixin ],

  props: {
    component: {
      required: true
    }
  }
};
</script>
